import styled from "styled-components"

export const Main = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 92px;
  position: relative;

  & > img {
    width: 259px;
    height: 698px;
    position: absolute;
    left: 0;
    top: 200px;
    z-index: -1;
  }
`

export const Wrapper = styled.div`
  width: 83.3%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 27px;

  @media (max-width: 1149px) {
    width: 82.5%;
  }

  @media (max-width: 799px) {
    width: 88.88%;
  }

  & > h3 {
    font-size: 2.3rem;
    font-weight: 700;
    line-height: 3.5rem;
    letter-spacing: 0;
    background: linear-gradient(
      90.32deg,
      #ce9638 0%,
      #eae69c 52.96%,
      #ce9638 105.92%
    );
    -webkit-text-fill-color: transparent;
    -webkit-background-clip: text;
  }
`

export const OpinionsComponent = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 20px;
  padding-bottom: 72px;
`

export const SingleSide = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`

export const SingleOpinion = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: rgba(17, 17, 17, 0.75);
  padding: 20px 30px 0 30px;
  padding-bottom: 22px;

  p {
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 2.1rem;
    letter-spacing: 0;
    color: #fdfdfd;
  }
`

export const PersonBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  height: 35px;
  gap: 20px;

  img {
    width: 35px;
    height: 35px;
  }

  h5 {
    font-size: 1.4rem;
    font-weight: 700;
    line-height: 2.1rem;
    letter-spacing: 0;
    color: #bb913c;
  }
`
